export default "__VITE_ASSET__BpXjchL___"